import { useState, useMemo } from 'react'

export const PRODUCT_SEARCH_EVENT_CHOSEN = 'product-search:chosen'

export const cartEventTypes = {
  [PRODUCT_SEARCH_EVENT_CHOSEN]: []
}

type ProductEventBusCallbackType<T> = (a: T) => void

export interface ProductEventBus<T> {
  on(event: string, cb: ProductEventBusCallbackType<T>): void
  off(event: string, cb: ProductEventBusCallbackType<T>): void
  offAll(): void
  triggerEvent: (event: string, payload: any) => void
}

export const useProductSearchEvents = <T>() => {
  const [ events, setEvents ] =
    useState<Record<string, ProductEventBusCallbackType<T>[]>>(cartEventTypes)

  return useMemo(
    () => ({

      /*
      Cart event bus
    */

      on (event: string, cb: ProductEventBusCallbackType<T>) {
        setEvents((events) => {
          if (events[event]) {
            return {
              ...events,
              [event]: [ ...events[event], cb ]
            }
          }
          return events
        })
        // if (events[event]) {
        //   setEvents(() => ({
        //     ...events,
        // [event]: [ ...events[event], cb ]
        //   }))
        // }
      },
      off (event: string, cb: ProductEventBusCallbackType<T>) {
        setEvents((events) => {
          if (events[event]) {
            return {
              ...events,
              [event]: events[event].filter((func) => func !== cb)
            }
          }
          return events
        })
        // if (events[event]) {
        //   setEvents(() => ({
        //     ...events,
        //     [event]: events[event].filter((func) => func !== cb)
        //   }))
        // }
      },
      offAll () {
        setEvents(cartEventTypes)
      },
      triggerEvent (event: string, data: T) {
        setEvents((events) => {
          if (events[event]) {
            events[event].map((cb) => cb(data))
          }

          return events
        })
      }
    }),
    []
  )
}
